import { normalizeSavedSearchUrlInput } from "./normalize-saved-search-url";

/**
 * Deterministic id for a saved search's server item (spec §3.2): hashing the
 * normalized path+search means re-enabling the same search updates one item
 * instead of accumulating duplicates, and absolute/relative variants collapse.
 * FNV-1a over UTF-8, base36 — no async crypto needed.
 */
export function savedSearchAlertId(storedUrl: string): string {
  const normalizedInput = normalizeSavedSearchUrlInput(storedUrl) || storedUrl.trim();
  let normalized: string;
  try {
    const parsed = new URL(normalizedInput, "https://www.jobcrawls.com");
    normalized = `${parsed.pathname}${parsed.search}`;
  } catch {
    normalized = normalizedInput;
  }
  const bytes = new TextEncoder().encode(normalized);

  let hashHigh = 0x811c9dc5;
  let hashLow = 0xcbf29ce4;
  for (const byte of bytes) {
    hashHigh = Math.imul(hashHigh ^ byte, 0x01000193) >>> 0;
    hashLow = Math.imul(hashLow ^ byte, 0x01000197) >>> 0;
  }
  return `${hashHigh.toString(36)}${hashLow.toString(36)}`;
}
